import { action, observable } from 'mobx';
const KeyGen = (function* (id) {
    while (true) {
        yield `modal-${id}`;
        id += 1;
    }
})(1);
const containerInstances = observable.array();
const removeInstance = action((instance) => {
    const index = containerInstances.indexOf(instance);
    if (index > -1) {
        containerInstances.splice(index, 1);
    }
});
const addInstance = action((instance) => {
    removeInstance(instance);
    containerInstances.unshift(instance);
});
function getKey() {
    return KeyGen.next().value;
}
function clear(closeByLocationChange) {
    containerInstances.forEach((instance) => {
        instance.clear(closeByLocationChange);
    });
}
const ModalManager = {
    addInstance,
    removeInstance,
    getKey,
    mousePositionEventBound: new WeakSet(),
    containerInstances,
    clear,
};
export default ModalManager;
